import { useMutation, useQuery } from "@tanstack/react-query";
import { CountyDto, SearchCountyDto } from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { CountyClient } from "../../../services/proxies/system/countyClient";
import { StateClient } from "../../../services/proxies";
import { OptionsDto } from "../../../assets/utils/lib/optionsDto";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";

export namespace CountyService {
  const countyClient = new CountyClient();
  const stateClient = new StateClient();

  export const save = () =>
    useMutation<IActionResult<CountyDto>, Error, CountyDto>({
      mutationFn: async (payload: CountyDto) => {
        return await countyClient.saveCountyAsync(payload);
      },
    });

  export const getCountyQuery = (countyId: string | undefined) =>
    useQuery({
      queryKey: ["countyQuery", countyId],
      queryFn: async () => await countyClient.getCountyAsync(countyId),
      enabled: Boolean(countyId),
    });

  export const getCountysQuery = (StateId: string | undefined) =>
    useQuery({
      queryKey: ["countysQuery", StateId],
      queryFn: async () => await countyClient.getCountysAsync(StateId),
      enabled: Boolean(StateId),
    });

  export const gridQuery = (searchQuery?: SearchCountyDto) =>
    useQuery({
      queryKey: ["countyGridQuery", searchQuery],
      queryFn: async () => await countyClient.searchCountysAsync(searchQuery),
      placeholderData: (previousData) => previousData,
    });

  export const getCountylookupQuery = () =>
    useQuery({
      queryKey: ["getStates"],
      queryFn: async () => await stateClient.getStatesAsync(),
      select: (data) => {
        const transformedData = data?.map((stateType) => ({
          display: stateType.name as string,
          value: stateType.id as string,
          key: stateType.id as string,
        }));
        return transformedData as DropdownOption[];
      },
    });

    export const deleteCounty = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (id: string | undefined) => {
                return await countyClient.deleteCountyAsync(id);
            },
        });
}
